import { useState } from 'react';
import type { TargetInfo } from './api';

type Product = Pick<TargetInfo, 'id' | 'label' | 'logo'>;

export function ProductIdentity({ product, placement }: { product: Product; placement: 'sidebar' | 'production' }) {
  const [failedLogo, setFailedLogo] = useState<string>();
  const initials = product.label.trim().split(/\s+/).map(word => word[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div className={`product-identity product-identity-${placement}`} data-testid={`product-identity-${placement}`}>
      {product.logo && failedLogo !== product.logo ? (
        <img className="product-logo" src={product.logo} alt="" aria-hidden onError={() => setFailedLogo(product.logo)} />
      ) : <span className="product-initials" aria-hidden>{initials}</span>}
      <span className="product-name">{product.label}</span>
    </div>
  );
}
